/*
in order to update this file in the web shop tell Claude to «push it»
*/

/*
Dynamic table of contents for the "editorial" article template — walks the
rendered h2/h3 headings inside the article body, builds a linked list of
them in the .article-toc nav (see sections/main-article-editorial.liquid,
"meta_rail" block), and highlights whichever section is currently in view
as the reader scrolls, the same way infinium.com's article TOC does.

Runs entirely client-side rather than in Liquid: article.content is
merchant-authored rich text, so headings can't be reliably id'd or counted
ahead of render time — this walks the actual rendered DOM instead.
*/

document.addEventListener('DOMContentLoaded', function () {
  var tocNav = document.querySelector('.article-toc');
  var contentEl = document.querySelector('.article-template__content');

  if (!tocNav || !contentEl) return;

  var headings = contentEl.querySelectorAll('h2, h3');
  if (!headings.length) return;

  var list = tocNav.querySelector('.article-toc__list');
  var usedIds = {};

  function slugify(text) {
    var slug = text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9äöüß\s-]/g, '')
      .replace(/\s+/g, '-');
    return slug || 'abschnitt';
  }

  headings.forEach(function (heading) {
    if (!heading.id) {
      var base = slugify(heading.textContent);
      var id = base;
      var counter = 1;
      while (usedIds[id]) {
        id = base + '-' + counter;
        counter += 1;
      }
      heading.id = id;
    }
    usedIds[heading.id] = true;

    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + heading.id;
    a.textContent = heading.textContent;
    a.className = 'article-toc__link';
    if (heading.tagName === 'H3') {
      a.classList.add('article-toc__link--sub');
    }
    a.setAttribute('data-toc-target', heading.id);
    li.appendChild(a);
    list.appendChild(li);
  });

  tocNav.classList.add('has-items');

  var links = tocNav.querySelectorAll('.article-toc__link');

  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      var target = document.getElementById(link.getAttribute('data-toc-target'));
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + link.getAttribute('data-toc-target'));
    });
  });

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var link = tocNav.querySelector('.article-toc__link[data-toc-target="' + entry.target.id + '"]');
        if (!link) return;
        links.forEach(function (l) {
          l.classList.remove('is-active');
        });
        link.classList.add('is-active');
      });
    },
    {
      // Treats a heading as "current" once it has scrolled into the top
      // 30% of the viewport and until it's scrolled past the top 10% —
      // matches the "highlight the section actually being read, not the
      // one that just barely appeared at the bottom" behaviour of
      // infinium.com's TOC rather than a naive "any visibility" check.
      rootMargin: '-10% 0px -70% 0px',
      threshold: 0,
    }
  );

  headings.forEach(function (heading) {
    observer.observe(heading);
  });
});
